/**
 * ¿El usuario ve los expedientes de varias empresas?
 *
 * Espejo de `apps/backend/utils/userScope.js`. Con empresas asignadas, el
 * usuario es de solo consulta y el listado necesita mostrar de qué empresa es
 * cada expediente: si no, no se distinguen entre sí.
 */
export const isGroupUser = user =>
  user?.role === 'company' &&
  Array.isArray(user?.company_ids) &&
  user.company_ids.length > 0;
